import {FormatterBasic} from "./Core/FormatterBasic";

export class TimeFormatter extends FormatterBasic {
    Format(): string {
        return this.GetValue('Value');
    }

}